let BASEURL = 'https://api.psylaris.nl/api';
const currentURL = window.location.href;

if (currentURL.includes('acc-emdr-remote') || currentURL.includes('localhost')) {
  BASEURL = 'https://api-acc-dot-turnkey-setup-246812.appspot.com/api';
  // baseURL = 'http://localhost:8081/api';
}

export default BASEURL;
